/* Polsk katalog for locale-payroll-runs-no.js (del 1 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'pay.overview': 'Przegląd płac',
  'pay.overviewSub': 'Zarejestrowane wynagrodzenia za rok obrotowy, pogrupowane według pracowników.',
  'pay.noPayBasis': 'Brak jeszcze podstawy wynagrodzeń',
  'pay.noPayBasisHint': 'Przegląd pojawi się tutaj, gdy listy płac zostaną zatwierdzone lub wypłacone.',
  'pay.noPeriodsHint': 'Składka pracodawcy i zaliczka na podatek pojawią się, gdy będziesz mieć zatwierdzone listy płac.',
  'pay.noOtpBasisHint': 'Podstawa emerytalna pojawi się, gdy będziesz mieć listy płac z kwotami emerytalnymi.',
  'pay.noHolidayPayHint': 'Podstawa dodatku urlopowego pojawi się, gdy będziesz mieć zatwierdzone listy płac w wybranym okresie.',
  'pay.noPayslipsHint': 'Paski wynagrodzenia pojawią się, gdy lista płac będzie zawierać pracowników.',
  'pay.noInboxVouchersHint': 'Tutaj pojawią się dokumenty, które nie zostały jeszcze zaksięgowane.',
  'pay.noEntriesHint': 'Dowody księgowe pojawią się po zatwierdzeniu listy płac.',
  'pay.noFixedLinesHint': 'Dodaj pracownikom stałe linie wynagrodzenia, aby używać ich na liście płac.',
  'pay.salaryTypeSearchHintFull': 'Najczęstsze typy są wyświetlane jako pierwsze. Wyszukaj lub wybierz „Pokaż więcej”, aby zobaczyć cały aktywny katalog.',
  'pay.overrideReasonSavedOnLineHint': 'Zapisywane w linii wynagrodzenia jako ślad audytowy.',
  'pay.salaryTypeSearchHintRest': 'Najczęstsze typy są wyświetlane jako pierwsze. Wyszukaj lub wybierz „Pokaż więcej”, aby zobaczyć resztę.',
  'pay.overrideReasonSavedOnFixedLineHint': 'Zapisywane w stałej linii.',
  'pay.payPeriodMonthOnlyHint': 'Listy płac obsługują na razie tylko okresy miesięczne.',
  'pay.calculationCodeOtherHint': 'Inne kody obliczeń będą dostępne, gdy zostaną wdrożone i sprawdzone.',
  'pay.runsAndEmployeesInline': 'Listy płac: {{runs}} · pracownicy: {{employees}}',
  'pay.fteShort': 'Etaty:',
  'pay.taxShort': 'Podatek:',
  'pay.netShort': 'Netto:',
  'pay.holidayPayShort': 'Dod. urlop.:',
  'pay.agaShort': 'AGA:',
  'pay.withholdingHelp': 'Zaliczka na podatek — podatek potrącany z wynagrodzenia brutto i odprowadzany do państwa w imieniu pracownika.',
  'pay.holidayPayHelp': 'Nabyty dodatek urlopowy — zwykle 10,2 % podstawy wynagrodzenia. Wypłacany w roku następującym po roku nabycia.',
  'pay.aga': 'AGA',
  'pay.agaHelp': 'Składka pracodawcy od wynagrodzenia — opłata, którą pracodawca płaci państwu oprócz kosztu wynagrodzenia.',
  'pay.fpShort': 'Dod. urlop.:',
  'pay.agaOfHolidayPay': 'AGA od dod. urlop.',
  'pay.agaOfHolidayPayHelp': 'Składka pracodawcy obliczona od nabytego dodatku urlopowego. Tworzy się rezerwę w miarę nabywania dodatku urlopowego.',
  'pay.fte': 'Etaty',
  'pay.fteHelp': 'Wymiar zatrudnienia przeliczony na pełne etaty. 1,00 = pełny etat, 0,50 = pół etatu.',
  'pay.overviewFilteredSub': 'Zarejestrowane wynagrodzenia za rok obrotowy, filtrowane według daty wypłaty.',
  'pay.grouping': 'Grupowanie',
  'pay.perEmployee': 'Według pracownika',
  'pay.perSalaryType': 'Według typu wynagrodzenia',
  'pay.employeeAndType': 'Pracownik i typ wynagrodzenia',
  'pay.againstWithholding': 'Na zaliczkę na podatek',
  'pay.againstAga': 'Na składkę pracodawcy',
  'pay.postedAs': 'Księgowane jako:',
  'pay.postedWithholdingOnly': '{{tax}} na 2600 zaliczka na podatek. Otwarte przed płatnością: {{openTax}}.',
  'pay.postedAgaOnly': '{{aga}} na 2770 składka pracodawcy. Otwarte przed płatnością: {{openAga}}.',
  'pay.postedBoth': '{{tax}} na 2600 zaliczka na podatek i {{aga}} na 2770 składka pracodawcy. Otwarte przed płatnością: podatek {{openTax}} i AGA {{openAga}}.',
  'pay.autoPostedAgainstWithholding': 'Płatność jest automatycznie księgowana na 2600 zaliczka na podatek i uznaje wybrane konto rozliczeniowe.',
  'pay.autoPostedAgainstAga': 'Płatność jest automatycznie księgowana na 2770 składka pracodawcy i uznaje wybrane konto rozliczeniowe.',
  'pay.autoPostedAgainstBoth': 'Płatność jest automatycznie księgowana na 2600 zaliczka na podatek i 2770 składka pracodawcy oraz uznaje wybrane konto rozliczeniowe.',
  'pay.agreedAnnualSalary': 'Uzgodnione wynagrodzenie roczne',
  'pay.agreedHourlyPay': 'Uzgodniona stawka godzinowa',
  'pay.withholdingSeparatePaymentNote': 'Zaliczkę na podatek od wynagrodzeń wypłaconych od 2026 r. płaci się osobno, najpóźniej pierwszego dnia roboczego po wypłacie wynagrodzeń.',
  'pay.recommendedForOtpPayment': 'Zalecane dla płatności OTP',
  'pay.otpPaymentPostingNote': 'Płatność jest księgowana na wybrane konto rozliczeniowe i używana w przeglądzie Emerytura/OTP. Linię bankową można następnie dopasować do dowodu płatności.',
  'pay.holidayPayAccruedLastYear': 'Dodatek urlopowy nabyty w zeszłym roku',
  'pay.holidayPayAccruedThisYear': 'Dodatek urlopowy nabyty w tym roku',
  'pay.ordinaryEmployment': 'Zwykły stosunek pracy',
  'pay.payslipUncheckAllNote': 'Odznacz wszystkich pracowników, jeśli paski wynagrodzenia mają zostać wysłane później. Można je wysłać z listy płac po zatwierdzeniu księgowania.',
  'pay.payslipPdfNotConnected': 'PDF paska wynagrodzenia nie jest połączony z backendem.',
  'pay.noSalaryLines': 'Brak linii wynagrodzenia',
  'pay.deletedOn': 'Usunięto {{date}}',
  'pay.payrollPaymentOn': 'Wypłata wynagrodzeń {{date}}',
  'pay.readyLinesForPayroll': 'Zatwierdzone linie gotowe do wypłaty: {{count}} ({{amount}}).',
  'pay.noReadyLinesForPayroll': 'Brak zatwierdzonych linii gotowych do wypłaty.',
  'pay.overrideAppliesFutureRuns': 'Nadpisanie dotyczy przyszłych list płac korzystających z tej stałej linii.',
  'pay.sentToLabel': 'wysyłane do',
  'pay.recommendedForPayrollPayment': 'Zalecane dla wypłaty wynagrodzeń',
  'pay.optionalNotePh': 'Opcjonalna notatka ...',
  'pay.openWithholding': 'Otwarta zaliczka na podatek',
  'pay.openAga': 'Otwarta składka pracodawcy',
  'pay.noPeriodPayments': 'Brak jeszcze płatności zarejestrowanych w tym okresie.',
  'pay.advance': 'Zaliczka',
  'pay.agaAndWithholding': 'Składka pracodawcy i zaliczka na podatek',
  'pay.agaAndWithholdingSub': 'Monitoruj zaliczkę na podatek i składkę pracodawcy z zatwierdzonych list płac w poszczególnych okresach.',
  'pay.withholdingLongHelp': 'Podatek potrącony z wynagrodzeń pracowników. Jest przechowywany na koncie potrąceń podatkowych i przekazywany państwu — nie możesz go wykorzystać.',
  'pay.agaLongHelp': 'Opłata, którą pracodawca płaci państwu od wynagrodzeń i świadczeń. Stawka zależy od strefy (gminy), w której znajduje się firma — 14,1 % w strefie 1.',
  'pay.toAuthority': 'Do Skatteetaten',
  'pay.toAuthorityHelp': 'Zaliczka na podatek plus składka pracodawcy — łączna kwota do zapłaty państwu za okres.',
  'pay.noPeriods': 'Brak jeszcze okresów',
  'pay.period2': 'Okres',
  'pay.payrollRunShort': 'Lista płac',
  'pay.pensionOtp': 'Emerytura / OTP',
  'pay.pensionOtpHelp': 'Obowiązkowa emerytura pracownicza (OTP) to ustawowo wymagane oszczędzanie na emeryturę pracowników — co najmniej 2 % wynagrodzenia. Tutaj rejestrujesz i monitorujesz wpłaty do dostawcy emerytury z zatwierdzonych list płac.',
  'pay.pensionPayments': 'Wpłaty emerytalne',
  'pay.pensionPaymentsSub': 'Rejestruj i monitoruj płatności OTP z zatwierdzonych list płac.',
  'pay.newPensionPayment': 'Nowa wpłata emerytalna',
  'pay.calculatedOtp': 'Obliczone OTP',
  'pay.calculatedOtpHelp': 'Łączna obliczona obowiązkowa emerytura pracownicza za rok, z zatwierdzonych list płac.',
  'pay.open2': 'Otwarte',
  'pay.unpaid': 'Nieopłacone',
  'pay.unpaidOtpHelp': 'OTP obliczone, ale jeszcze nie wpłacone do dostawcy emerytury.',
  'pay.otp': 'OTP',
  'pay.paidOtpHelp': 'OTP już wpłacone do dostawcy emerytury.',
  'pay.otpPaidWithDifference': 'Zapłacono {{paid}} · różnica {{difference}}',
  'pay.noOtpBasis': 'Brak podstawy OTP',
  'pay.payPeriod': 'Okres płacowy',
  'pay.pensionPayment': 'Wpłata emerytalna',
  'pay.otpRefPh': 'Np. OTP-06',
  'pay.holidayPayList': 'Lista dodatków urlopowych',
  'pay.holidayPayListSub': 'Nabyte i wypłacone dodatki urlopowe z zatwierdzonych list płac.',
  'pay.holidayPayBasis': 'Podstawa dodatku urlopowego',
  'pay.earned': 'Nabyte',
  'pay.noHolidayPay': 'Brak dodatków urlopowych',
  'pay.paymentDate': 'Data wypłaty',
  'pay.holidayPayBasisHelp': 'Suma wynagrodzeń uprawniających do dodatku urlopowego. Dodatek urlopowy oblicza się jako procent tej podstawy.',
  'pay.holidayPayEarnedHelp': 'Dodatek urlopowy nabyty do tej pory — zwykle 10,2 % podstawy (12 % przy pięciu tygodniach urlopu). Wypłacany w roku następującym po nabyciu.',
  'pay.holidayPayPaidHelp': 'Dodatek urlopowy już wypłacony pracownikom w tym roku.',
  'pay.voucherShort': 'Dokument:',
  'pay.paidOutShort': 'Wypł.:',
  'pay.earnedShort': 'Nabyte:',
  'pay.paidShort': 'Wypłacono:',
  'pay.salaryLine': 'Pozycja płacowa',
  'pay.newLine': 'Utwórz nową pozycję',
  'pay.taxResidentCountry': 'Rezydencja podatkowa w kraju',
  'pay.earningCountry': 'Kraj uzyskiwania dochodu',
  'pay.earningRelation': 'Rodzaj stosunku zarobkowego',
  'pay.noPrefill': 'Nie wypełniaj wstępnie kwoty/ilości tej pozycji w nowych listach płac',
  'pay.holidayPayPayout': 'Wypłata dodatku urlopowego',
  'pay.addHolidayPay': 'Dodaj dodatek urlopowy',
  'pay.earnedEarlier': 'Nabyte wcześniej',
  'pay.earnedThisYear': 'Nabyte w tym roku',
  'pay.pensionContribution': 'Składka/premia emerytalna',
  'pay.registerPensionContribution': 'Zarejestruj składkę/premię emerytalną',
  'pay.fetchNavRefunds': 'Pobierz refundacje z NAV',
  'pay.fetchNavRefundsSub': 'Pobierz refundacje do uwzględnienia na liście płac.',
  'pay.emailPayslips': 'Wyślij paski wynagrodzenia e-mailem',
  'pay.sendPayslips': 'Wyślij paski wynagrodzenia',
  'pay.sendLater': 'Wyślij później',
  'pay.sendPayslip': 'Wyślij pasek wynagrodzenia',
  'pay.sendAllPayslips': 'Wyślij do wszystkich',
  'pay.sending': 'Wysyłanie ...',
  'pay.payslipSendFailed': 'Nie udało się wysłać paska wynagrodzenia.',
  'pay.payslipSendUnavailable': 'Wysyłka pasków wynagrodzenia nie jest połączona z backendem.',
  'pay.downloadPayslip': 'Pobierz pasek wynagrodzenia',
  'pay.downloadAllPdf': 'Pobierz wszystkie (PDF)',
  'pay.downloading': 'Pobieranie ...',
  'pay.sendTime': 'Czas wysyłki',
  'pay.payslipsAfterPosting': 'Paski wynagrodzenia można pobrać po zaksięgowaniu listy płac.',
  'pay.noPayslipsShort': 'Brak pasków wynagrodzenia',
  'pay.paymentInfo': 'Informacje o wypłacie',
  'pay.copyToClipboard': 'Kopiuj do schowka',
  'pay.downloadExcel': 'Pobierz Excel',
  'pay.registerPayment': 'Zarejestruj wypłatę',
  'pay.paymentsFromOperating': 'Wypłaty z rachunku bieżącego:',
  'pay.toBankAccount': 'Na rachunek bankowy',
  'pay.paidOutDate': 'Data wypłaty',
  'pay.bankTip': 'Wskazówka! Nie zapomnij wykonać faktycznej płatności zaliczki na podatek i wynagrodzeń w bankowości internetowej.',
  'pay.linkVoucher': 'Połącz dokument',
  'pay.noInboxVouchers': 'Brak dokumentów w skrzynce odbiorczej',
  'pay.newSalaryLine': 'Nowa pozycja płacowa',
  'pay.paidOutVerb': 'Wypłata',
  'pay.agaShort2': 'AGA',
  'pay.holiday': 'Urlop',
  'pay.noExtraLines': 'Nie dodano jeszcze dodatkowych pozycji płacowych.',
  'pay.showEmployeePage': 'Pokaż stronę pracownika',
  'pay.addSalaryLine': 'Dodaj pozycję płacową',
  'pay.noEmployeesInRun': 'Brak pracowników na liście płac',
  'pay.holidayPensionDeductions': 'Dodatek urlopowy, emerytura i potrącenia',
  'pay.pensionContributionOrPremium': 'Składka lub premia emerytalna',
  'pay.summary': 'Podsumowanie',
  'pay.payrollRun': 'Lista płac',
  'pay.agaRate': 'Składka pracodawcy (14,1 %)',
  'pay.posting': 'Księgowanie',
  'pay.writeComment': 'Napisz komentarz',
  'pay.seePayslips': 'Zobacz paski wynagrodzenia',
  'pay.nextStep': 'Następny krok',
  'pay.sendAmeldingToAltinn': 'Wyślij A-melding do Altinn',
  'pay.deletePayrollRun': 'Usuń listę płac',
  'pay.manualSubmission': 'Ręczne złożenie',
  'pay.sendAmelding': 'Wyślij A-melding',
  'pay.altinnConfirmation': 'Potwierdzenie z Altinn',
  'pay.altinnConfirmationHelp': 'Po wysłaniu A-melding poczekaj na potwierdzenie, zanim zostaną utworzone paski wynagrodzenia.',
  'pay.createPayslips': 'Utwórz paski wynagrodzenia',
  'pay.editPayrollRun': 'Edytuj listę płac',
  'pay.registerPaymentToEmployees': 'Zarejestruj płatność dla pracowników i podatku',
  'pay.cancelPosting': 'Anuluj księgowanie',
  'pay.cancelPostingConfirmTitle': 'Anulować księgowanie?',
  'pay.cancelPostingConfirmMessage': 'Lista płac wróci do szkicu. Zarejestrowane wypłaty i samo księgowanie zostaną anulowane i usunięte z aktywnych danych księgowych. Musisz ponownie sprawdzić i zatwierdzić wynagrodzenia.',
  'pay.cancelPostingConfirmAction': 'Anuluj księgowanie',
  'pay.keepPosting': 'Zachowaj księgowanie',
  'pay.seeAccountingVoucher': 'Zobacz dowód księgowy',
  'pay.registerPayments': 'Zarejestruj wypłaty',
  'pay.payrollDone': 'Wynagrodzenia są naliczone i zaksięgowane!',
  'pay.payrollDoneSub': 'Lista płac została zgłoszona, zaksięgowana i zarejestrowana jako wypłacona.',
  'pay.allPayrollRuns': 'Wszystkie listy płac',
  'pay.noEntries': 'Brak księgowań',
  'pay.calculatedWithholding': 'Obliczona zaliczka na podatek',
  'pay.toPayOut': 'Do wypłaty',
  'pay.activePayrollRuns': 'Aktywne listy płac',
  'pay.runsCount': 'Listy płac: {{count}}',
  'pay.employeesInActiveRuns': 'Pracownicy na aktywnych listach płac: {{count}}',
  'pay.createNewRunHint': 'Utwórz nową listę płac, aby pobrać pracowników, stałe pozycje płacowe i zatwierdzone podróże.',
  'pay.activePayrollRunsHelp': 'Lista płac oblicza wynagrodzenie, zaliczkę na podatek, dodatek urlopowy i składkę pracodawcy za dany okres. Aktywne listy są w trakcie przygotowania.',
  'pay.newPayrollRun': 'Nowa lista płac',
  'pay.noActiveRuns': 'Brak aktywnych list płac',
  'pay.earlierPayrollRuns': 'Wcześniejsze listy płac',
  'pay.earlierPayrollRunsHelp': 'Listy płac, których wypłata została zarejestrowana. Możesz je otworzyć, aby zobaczyć szczegóły, paski wynagrodzenia i dowody księgowe.',
  'pay.orderNumberDate': 'Najnowsza wypłata najpierw',
  'pay.travelAndExpenses': 'Podróże i wydatki',
  'pay.createPayrollRun': 'Utwórz nową listę płac',
  'pay.payrollRunDate': 'Data listy płac',
  'pay.payPeriodMonthHelp': 'Miesiąc, którego dotyczy wynagrodzenie. Data wypłaty może być inna.',
  'pay.paymentDateHelp': 'Data faktycznej wypłaty pieniędzy. Nie zmienia okresu płacowego.',
  'pay.paymentDatePeriodWarning': 'Data wypłaty wypada poza zwykłym miesiącem okresu płacowego. Sprawdź, czy okres i data są poprawne.',
  'pay.includeFixedLines': 'Uwzględnij stałe pozycje płacowe',
  'pay.includeExpenseLines': 'Uwzględnij pozycje wydatków',
  'pay.readyExpenseLineCount': 'Pozycje gotowe do wypłaty: {count}',
  'pay.payPeriodLength': 'Okres płacowy (długość okresu nabywania)',
  'pay.ordinaryWithholding': 'Zwykła zaliczka na podatek',
  'pay.useTaxCard': 'Użyj karty podatkowej, gdy jest dostępna',
  'pay.optionalComment': 'Komentarz opcjonalny',
  'pay.salaryTypesAndDeductions': 'Rodzaje wynagrodzeń i potrąceń',
  'pay.salaryTypesHelp': 'Rodzaje wynagrodzeń określają, jak pozycja płacowa jest traktowana dla AGA, zaliczki na podatek, dodatku urlopowego i emerytury.',
  'pay.newSalaryType': 'Nowy rodzaj wynagrodzenia',
  'pay.agaLiableHelp': 'Czy rodzaj wynagrodzenia wchodzi do podstawy składki pracodawcy. Zaznaczone = podlega.',
  'pay.withholdingLiableHelp': 'Czy rodzaj wynagrodzenia podlega potrąceniu — czyli czy od kwoty należy pobrać zaliczkę na podatek.',
  'pay.holidayPayLiableHelp': 'Czy rodzaj wynagrodzenia wchodzi do podstawy dodatku urlopowego — czyli czy od kwoty nabywa się dodatek urlopowy.',
  'pay.pension': 'Emerytura',
  'pay.pensionLiableHelp': 'Czy rodzaj wynagrodzenia wchodzi do podstawy obowiązkowej emerytury pracowniczej (OTP).',
  'pay.rules': 'Reguły',
  'pay.noLiabilityRules': 'Brak reguł składek lub potrąceń',
  'pay.noEffect': 'Bez wpływu',
  'pay.bonusExamplePh': 'Np. Premia bez dodatku urlopowego',
  'pay.benefitInKind': 'Świadczenie w naturze',
  'pay.deduction': 'Potrącenie',
  'pay.taxFreeAllowance': 'Zwrot wolny od potrąceń',
  'pay.overrideNote': 'Zmiany są zapisywane jako nadpisanie typu standardowego przez firmę.',
  'pay.ratePerMonth': 'Stawka (miesięcznie)',
  'pay.calculated': 'Obliczane',
  'pay.changeCountries': 'Zmień kraj uzyskiwania dochodu/rezydencji',
  'pay.optionalCommentPh': 'Komentarz opcjonalny ...',
  'pay.fixedSalaryLines': 'Stałe pozycje płacowe',
  'pay.fixedSalaryLinesSub': 'Pozycje płacowe powtarzane automatycznie na każdej liście płac.',
  'pay.addFixedLine': 'Dodaj stałą pozycję płacową',
  'pay.noFixedLines': 'Brak stałych pozycji płacowych',
  'pay.payrollSettings': 'Ustawienia płac',
  'pay.payrollSettingsSub': 'Ustawienia domyślne używane, gdy Plumme księguje wynagrodzenia, składkę pracodawcy, dodatek urlopowy i emeryturę.',
  'pay.contributionAndHoliday': 'Składka i dodatek urlopowy',
  'pay.agaZone': 'Strefa składki pracodawcy',
  'pay.holidayPayRate': 'Stawka dodatku urlopowego',
  'pay.pensionOtpShort': 'Emerytura (OTP)',
  'pay.pensionProvider': 'Dostawca planu emerytalnego',
  'pay.providerOrgNo': 'Nr org. dostawcy',
  'pay.otpRate': 'Stawka OTP',
  'pay.accountsAndReporting': 'Konta i raportowanie',
  'pay.payrollAccount': 'Rachunek płacowy (bank)',
  'pay.withholdingAccount': 'Rachunek zaliczek podatkowych',
  'pay.firstPayrollYear': 'Pierwszy rok księgowania płac',
  'pay.entityNumber': 'Numer zakładu',
  'pay.holidayPayPercent': 'Procent dodatku urlopowego',
  'pay.holidayPayPercentHelp': 'Stawka, według której nabywa się dodatek urlopowy. 10,2 % to ustawowe minimum; 12 % obowiązuje przy uzgodnionych pięciu tygodniach urlopu.',
  'pay.holidayPayMonth': 'Miesiąc wypłaty dodatku urlopowego',
  'pay.month.january': 'Styczeń',
  'pay.month.february': 'Luty',
  'pay.month.march': 'Marzec',
  'pay.month.april': 'Kwiecień',
  'pay.month.june': 'Czerwiec',
  'pay.month.july': 'Lipiec',
  'pay.month.august': 'Sierpień',
  'pay.month.september': 'Wrzesień',
  'pay.month.october': 'Październik',
  'pay.month.november': 'Listopad',
  'pay.month.december': 'Grudzień',
  'pay.shift.none': 'Bez pracy zmianowej',
  'pay.shift.shift': 'Praca zmianowa',
  'pay.shift.rota': 'Grafik rotacyjny',
  'pay.shift.continuous': 'Praca zmianowa w ruchu ciągłym',
  'pay.ordinary': 'Zwykły',
  'pay.maritime': 'Morski',
  'pay.freelancer': 'Freelancer',
  'pay.pensionOrOtherBenefit': 'Emerytura lub inne świadczenie',
  'pay.municipalityAndNumber': 'Gmina i numer gminy',
  'pay.pickMunicipality': 'Wybierz gminę',
  'pay.calculationCode': 'Kod obliczenia',
  'pay.generalIndustries': 'Branże ogólne',
  'pay.agricultureForestry': 'Rolnictwo i leśnictwo',
  'pay.fishing': 'Rybołówstwo i łowiectwo',
  'pay.pensionProviderOtp': 'Dostawca planu emerytalnego (OTP)',
  'pay.withholdingAccounts': 'Konta potrąceń',
  'pay.payoutAccount': 'Rachunek do wypłaty wynagrodzeń',
  'pay.amelding': 'A-melding',
  'pay.everyMonth': 'Co miesiąc',
  'pay.everyPayrollRun': 'Przy każdej liście płac',
  'pay.taxCardChangeAlert': 'Powiadomienie o zmianie karty podatkowej',
  'pay.emailPh': 'imie@firma.pl',
  'pay.sms': 'SMS',
  'pay.savingsAccount': 'Rachunek oszczędnościowy',
  'pay.withholdingMode.fiftyPercent': '50 % zaliczki na podatek',
  'pay.withholdingMode.standardHint': 'Używa ważnej karty podatkowej zarejestrowanej dla pracownika. Jeśli jej brak, potrąca się 50 %.',
  'pay.withholdingMode.taxCardHint': 'Karty podatkowe nie są jeszcze pobierane automatycznie ze Skatteetaten. Plumme używa karty podatkowej zarejestrowanej dla pracownika i potrąca 50 %, gdy brak ważnej karty.',
  'pay.withholdingMode.fiftyPercentHint': 'Potrąca 50 % podstawy potrącenia wszystkim pracownikom na tej liście płac, niezależnie od karty podatkowej.',
  'pay.holidayPayPrevious.hint': 'Kwota nabyta w zeszłym roku jest obliczana z zatwierdzonych list płac z zeszłego roku, pomniejszona o to, co już wypłacono. Dodatek urlopowy nabyty przed rozpoczęciem korzystania z Plumme nie jest uwzględniony – dostosuj kwotę ołówkiem.',
  'pay.deductionAccount.label': 'Konto uznawane potrąceniem',
  'pay.deductionAccount.hint': 'Potrącenia przekazywane innym są zobowiązaniami. Wybierz 2610 dla zajęcia wynagrodzenia. Plumme nie raportuje zajęć wynagrodzenia w A-melding – potrącenie trzeba przekazać osobno.',
  'pay.deductionAccount.canteen': '5919 Potrącenie kosztów stołówki pracowników',
  'pay.deductionAccount.garnishment': '2610 Zajęcie wynagrodzenia',
  'pay.deductionAccount.unionDues': '2650 Potrącona składka związkowa',
  'pay.deductionAccount.other': '2690 Inne potrącenia',
  'pay.taxRuleUnsupportedError': 'Plumme nie obsługuje jeszcze reguły: {rule} – rozlicz wynagrodzenie dla {employee} poza Plumme.',
  'err.payroll.unsupportedTaxRule': 'Pracownik na liście płac podlega regule podatkowo-składkowej, której Plumme jeszcze nie obsługuje. Rozlicz wynagrodzenie tego pracownika poza Plumme.',
  'pay.taxRules.svalbard': 'Svalbard',
  'pay.taxRules.janMayen': 'Jan Mayen i terytoria zależne',
  'pay.taxRules.seafarerDeduction': 'szczególne odliczenie dla marynarzy',
  'pay.taxRules.charity': 'organizacja charytatywna lub pożytku publicznego',
  'pay.taxRules.netPay': 'wynagrodzenie netto',
  'pay.taxRules.netPaySeafarer': 'wynagrodzenie netto dla marynarzy',
  'pay.taxRules.pensionSourceTax': 'podatek u źródła od emerytur',
  'pay.taxRules.nanny': 'opiekunka w domu dziecka',
  'pay.taxRules.homeWork': 'praca zarobkowa w gospodarstwie domowym',
  'pay.taxRules.taxFreeOrganization': 'organizacja zwolniona z podatku',
  'pay.pensionAllocation.explain': 'Składka zastępuje obliczone OTP dla wybranych pracowników. Jeśli wybierzesz kilku, kwota zostanie podzielona według ich podstawy OTP.',
  'pay.pensionAllocation.employees': 'Pracownicy, których dotyczy składka',
  'pay.pensionAllocation.amountRequired': 'Podaj kwotę większą niż 0.',
  'pay.pensionAllocation.noEmployees': 'Wybierz co najmniej jednego pracownika, którego dotyczy składka.',
  'pay.pensionAllocation.noBasis': 'Wybrani pracownicy nie mają podstawy OTP na tej liście płac. Wybierz jednego pracownika lub najpierw dodaj wynagrodzenie.',
  'pay.pensionAllocation.noLines': 'Lista płac nie zawiera pracowników, do których można przypisać składkę emerytalną.',
  'pay.pensionAllocation.saveFailed': 'Nie udało się zarejestrować składki emerytalnej.',
  'pay.travelNotPayableError': 'Tych rozliczeń podróży lub wydatków nie można już wypłacić na tej liście płac: {travels}. Zostały już wypłacone na innej liście lub nie są zatwierdzone. Usuń je ze szkicu albo odwróć listę, która je wypłaciła.',
  'err.payroll.travelNotPayable': 'Rozliczenie podróży lub wydatek na tej liście płac zostało już wypłacone na innej liście albo nie jest już zatwierdzone. Usuń pozycję ze szkicu przed zatwierdzeniem.',
  'pay.noCalculationBasis': 'Brak podstawy obliczenia',
  'pay.payTypeGroup.common': 'Popularne',
  'pay.payTypeGroup.custom': 'Własne typy wynagrodzeń',
  'pay.payTypeGroup.other': 'Inne typy wynagrodzeń',
  'pay.payTypeGroup.benefitInKind': 'Świadczenia niepieniężne',
  'pay.payTypeGroup.deduction': 'Potrącenia',
  'pay.payTypeGroup.taxFreeAllowance': 'Dodatki wolne od potrąceń',
  'pay.inactive': 'nieaktywny',
  'pay.selectSalaryType': 'Wybierz typ wynagrodzenia',
  'pay.searchSalaryTypeOrRule': 'Szukaj typu wynagrodzenia lub reguły',
  'pay.showMoreSalaryTypes': 'Pokaż więcej typów wynagrodzeń',
  'pay.calculationRules': 'Reguły obliczeń',
  'pay.agaAndTaxTab': 'Składka pracodawcy i podatek',
  'pay.pensionOtpTab': 'Emerytura/OTP',
  'pay.zone': 'Strefa',
  'pay.status.paid': 'Zapłacono',
  'pay.status.unpaid': 'Niezapłacone',
  'pay.status.approved': 'Zatwierdzone',
  'pay.status.annulled': 'Anulowane',
  'pay.status.draft': 'Szkic',
  'pay.status.partiallyPaid': 'Częściowo zapłacone',
  'pay.select': 'Wybierz',
  'pay.search': 'Szukaj',
  'pay.noDataYet': 'Brak danych',
  'pay.noDataYetBody': 'Gdy pojawią się wpisy, zostaną wyświetlone tutaj.',
  'pay.notSet': 'Nie ustawiono',
  'pay.thisIsADeduction': 'To jest potrącenie',
  'pay.fixedLineHint.payout': 'Pozycja jest wypłacana pracownikowi',
  'pay.fixedLineHint.taxable': 'Podlega potrąceniu - wliczana do zaliczki na podatek',
  'pay.fixedLineHint.employerContribution': 'Wliczana do podstawy składki pracodawcy',
  'pay.fixedLineHint.holidayPay': 'Wliczana do podstawy dodatku urlopowego',
  'pay.fixedLineHint.pension': 'Wliczana do podstawy emerytury (OTP)',
  'pay.fixedLineHint.deduction': 'Kwota ujemna - potrącana z wypłaty',
  'pay.amountMustBePositive': 'Kwota musi być większa niż 0.',
  'pay.amountExceedsOpenTerm': 'Kwota nie może przekraczać kwoty otwartej w danym okresie.',
  'pay.allocationMustMatchAmount': 'Podział musi być równy kwocie i nie może przekraczać kwot otwartych.',
  'pay.paymentUpdated': 'Zaktualizowano płatność.',
  'pay.paymentRegistered': 'Zarejestrowano płatność.',
  'pay.savePaymentFailed': 'Nie udało się zapisać płatności.',
  'pay.paymentAnnulled': 'Anulowano płatność.',
  'pay.annulPaymentFailed': 'Nie udało się anulować płatności.',
  'pay.allPensionPaymentsRegistered': 'Wszystkie wpłaty emerytalne są zarejestrowane.',
  'pay.noOtpToRegisterYet': 'Brak obliczonego OTP do zarejestrowania.',
  'pay.missingPayrollRunForOtp': 'Brak listy płac dla płatności OTP.',
  'pay.pensionPaymentRegistered': 'Zarejestrowano płatność emerytalną.',
  'pay.registerPensionPaymentFailed': 'Nie udało się zarejestrować płatności emerytalnej.',
  'pay.explainRuleOverrideRequired': 'Uzasadnij, dlaczego reguły obliczeń są nadpisywane.',
  'pay.navRefundsFetched': 'Pobrano refundacje z NAV.',
  'pay.navRefundsFetchFailed': 'Nie udało się pobrać refundacji z NAV.',
  'pay.payslipDownloaded': 'Pobrano pasek wynagrodzenia.',
  'pay.payslipDownloadFailed': 'Nie udało się pobrać paska wynagrodzenia.',
  'pay.payslipsDownloaded': 'Pobrano paski wynagrodzeń.',
  'pay.payslipsDownloadFailed': 'Nie udało się pobrać pasków wynagrodzeń.',
  'pay.paymentInfoCopied': 'Skopiowano informacje o wypłacie.',
  'pay.paymentFileDownloaded': 'Pobrano plik wypłat.',
  'pay.linkInboxDocumentFailed': 'Nie udało się powiązać dokumentu ze skrzynki odbiorczej.',
  'pay.payrollRunCreated': 'Utworzono wypłatę wynagrodzeń.',
  'pay.payrollRunCreateFailed': 'Nie udało się utworzyć wypłaty wynagrodzeń.',
  'pay.payrollRunUpdateFailed': 'Nie udało się zaktualizować wypłaty wynagrodzeń.',
  'pay.deletedPayrollRunRemoved': 'Usunięto skasowaną wypłatę wynagrodzeń.',
  'pay.removePayrollRunFailed': 'Nie udało się usunąć wypłaty wynagrodzeń.',
  'pay.commentSaved': 'Zapisano komentarz.',
  'pay.salaryLineAdded': 'Dodano linię płacową.',
  'pay.voucherLinkedToPayrollRun': 'Dokument powiązano z wypłatą wynagrodzeń.',
});
